module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/impression_icon01-8403d94205b25d80a14311b79f7b0636.png";